import $ from 'jquery';
import '../../libs/js/jquery-qrcode-0.15.0.min.js';
import { getQueryVariable, showAlert } from '../utils-module.js';
import { addVisitDateInfo } from '../../../../packages/src/api/index.js';
import { pageParams } from '../page.js';
import { pageRoutes, redirectToPage } from '../page-routes.js';
import { initEmailOrPhoneInput } from '../../../../packages/src/components/inputEmailOrPhoneNumber/index.ts';
import { validateSync } from '../../../../packages/src/modules/validator/index.ts';
import { prepareSchema } from '../../../../packages/src/modules/validator/schemaEmailAndPhoneNumber.ts';

const { eventName, attendeeUid: getAttendeeUid } = pageParams;

export function prepareRegPage() {
  const eventNameQueryParam = getQueryVariable('eName');
  if (eventNameQueryParam) {
    pageParams.saveEventName(eventNameQueryParam);
  }
  if (!pageParams.homeLink()) {
    const homeLink = window.location.href.replace(/\/[^/]+\.html/, `/${pageRoutes.index}`);
    if (homeLink) {
      pageParams.saveHomeLink(homeLink);
    }
  }
}

export function getStep() {
  return localStorage.getItem('step') || '1';
}

export function isSecondStep() {
  return getStep() === '2';
}

export function goToSecondStep() {
  localStorage.setItem('step', '2');
}

export function isValidToken(tokenA, tokenB) {
  if (!tokenA || !tokenB) return false;
  return tokenA === tokenB;
}

export async function unlockAccount() {
  await addVisitDateInfo({
    eventName: getQueryVariable('eName'),
    uId: getAttendeeUid(),
    vDate: new Date(),
    prePaid: true,
  });
}

export function renderAttendeeQR(attendeeUid) {
  // NOTE: setTimeout is needed here to fix bug with iPhone because script of qrcode plugin is loaded after this code
  setTimeout(() => {
    const $qrCodeCont = $('.qrCode__code');
    const $qrCodeText = $('.qrCode__text');
    $qrCodeCont.html('');
    const size = parseInt($qrCodeCont.css('width'), 10) - parseInt($qrCodeCont.css('border-width'), 10) * 2;
    $qrCodeCont.qrcode({
      text: attendeeUid,
      label: attendeeUid,
      size,
      mode: 0,
      mSize: 0.045,
      mPosX: 0.5,
      mPosY: 0.5,
      fontcolor: '#000',
      fontname: 'Arial',
      ecLevel: 'H',
      render: 'image',
    });
    $qrCodeText.html(attendeeUid);
  }, 0);
}

export function isNeedToShowPrivacy(opts) {
  return !isEmptyParsedOpts(opts) && Boolean(opts.agreementText);

  function isEmptyParsedOpts(parsedOpts) {
    return Object.keys(parsedOpts || {}).length === 0;
  }
}

export function redirectToHome() {
  window.location.href = localStorage.getItem('locWA');
}

export function generateUrlForEmail() {
  const [currentStringURL] = localStorage.getItem('locWA').split('?');
  const currentURL = new URL(currentStringURL);
  currentURL.searchParams.set('eName', eventName());
  return currentURL.href;
}

export function initRegForm() {
  let isEnablePhoneNumber = false;
  let isEnableSMSAgreement = false;
  let isEnablePrivacy = false;

  const emailOrPhoneInput = initEmailOrPhoneInput();

  return {
    enableAgreePrivacy,
    enablePhoneNumber,
    onSubmit,
  };

  function enableAgreePrivacy() {
    isEnablePrivacy = true;
    const $elem = document.querySelector('#agree-privacy');
    $elem.style.display = 'inline-flex';
  }

  function enablePhoneNumber(agreementText) {
    emailOrPhoneInput.enablePhoneNumber();
    isEnablePhoneNumber = true;

    if (agreementText) {
      isEnableSMSAgreement = true;
      const $smsAgreement = document.querySelector('#sms-agree .checkbox__text');
      $smsAgreement.textContent = agreementText;
    }

    emailOrPhoneInput.onChangeMode((mode) => {
      const $smsCheckbox = document.querySelector('#sms-agree');

      if (agreementText) {
        if (mode === 'phoneWithCountryCode' || mode === 'phoneWithoutCountryCode') {
          $smsCheckbox.style.display = 'inline-flex';
        } else {
          $smsCheckbox.style.display = 'none';
        }
      }
    });
  }

  function extractAttendeeName() {
    return $('#attendeeName').val().trim();
  }

  function extractAttendeeEmailOrPhoneNumber() {
    return emailOrPhoneInput.get();
  }

  function extractIsCheckedAgreeWithSMSAgreement() {
    const $elem = document.querySelector('#sms-agree');
    return $elem.classList.contains('checkbox_checked');
  }

  function extractIsCheckedAgreeWithPrivacy() {
    const $elem = document.querySelector('#agree-privacy');
    return $elem.classList.contains('checkbox_checked');
  }

  function onSubmit(cb) {
    $('#createAtt')
      .click(async () => {
        validateSync({
          schema: prepareSchema({
            isEnabledSMSAgreement: isEnableSMSAgreement && emailOrPhoneInput.contentType() === 'phone',
            isEnabledPhoneNumber: isEnablePhoneNumber,
            isEnabledCheckedAgreeWithPrivacy: isEnablePrivacy,
          }),
          values: {
            contact: extractAttendeeEmailOrPhoneNumber(),
            agreeWithSMSAgreement: extractIsCheckedAgreeWithSMSAgreement(),
            agreeWithPrivacy: extractIsCheckedAgreeWithPrivacy(),
          },
          onError: (error) => {
            showAlert(error.errors[0]);
          },
          onSuccess: () => {
            cb(getData());
          },
        });
      })
      .prop('disabled', false);
  }

  function getData() {
    const result = {
      name: extractAttendeeName(),
    };

    const contact = extractAttendeeEmailOrPhoneNumber();

    if (isEmail(contact)) {
      result.email = contact;
    } else {
      result.phoneNumber = contact;
    }

    return result;
  }
}

export function getErrorRegFallBecauseOfAttendeeNull({ canBeEmailConfirmationProblem = false } = {}) {
  if (isDev() && canBeEmailConfirmationProblem) {
    return 'Failed to create an attendee. Please try again later. Check please your email is confirmed.';
  }
  return 'Failed to create an attendee. Please try again later.';

  function isDev() {
    return /dev-|localhost/.test(process.env.BACKEND_API);
  }
}

export function initPrivacyPolicyLink() {
  document.querySelector('#privacy-policy').addEventListener('click', () => {
    redirectToPage.privacyPolicy();
  });
}

function isEmail(value) {
  return /@/.test(value);
}
